angular.module('ApptBookApp').service('appointmentBookGlobalsService', [
    function() {
        return {
            setDefaults() {
                this.appointmentBookLoaded = false;
                this.lastRequestedDimension = 0;
                this.scrollTime = undefined;
                this.extraScrollTime = undefined;
                this.showLeaves = false;
                this.displayPrecisionTimingToggle = false;
                if (this.opacityFilterSelections) {
                    this.opacityFilterSelections.appointmentId = undefined;
                }
                this.isPasting = false;
            },
            opacityFilterSelectionsDefaults: {
                appointStatusFilter: {
                    value: 'AllServices',
                    label: '',
                    text: '',
                    appointmentTransitionStateEnum: [],
                    appointmentFinalStateEnum: [],
                },
                confirmStatusFilter: {
                    value: 'AllStatuses',
                    label: '',
                    text: '',
                    appointConfirmStateEnum: [],
                },
                hasNotes: false,
                hasClientNotes: false,
                bookedOnline: false,
                bookedViaBookingAgent: false,
                numberOfVisits: -1,
                selectedResource: undefined,
                selectedEquipment: undefined,
                selectedApptCategory: undefined,
                program: undefined,
                isFirstTimeServiceCategoryBooked: false,
                isNewClient: false,
                isWalkin: false,
                isUnassignedEmployee: false,
                isRebooked: false,
                isRepeatClientBusiness: false,
                isRepeatClientEmployee: false,
                hasUnsubmittedForms: false,
                bookedViaMyMeevo: false
            },
            displayNoShows: true,
            cellHeight: 35,
            cellHeightPercent: undefined,
            headerCellHeight: 35,
            constCellHeight: 35,
            columnWidth: 200,
            columnWidthPercent: undefined,
            constColumnWidth: 200,
            defaultColumnPercent: 100,
            defaultRowPercent: 100,
            leftRightBorderWidth: 2,
            headerMargin: 0,
            containerOffset: 0,
            appointmentLeftBarWidth: 20,
            headerOffset: 0,
            numberOfDimensionsPerRequest: 10,
            pageSize: 100,
            totalPages: 1,
            currentPage: 1,
            pages: [],
            timeColumnWidth: 100,
            timeCellWidth: 50,
            countWidth: 40,
            columnDateFormat: 'M/D/YYYY',
            bookStartTime: undefined,
            bookEndTime: undefined,
            appointmentBookLoaded: false,
            filterBarHeight: 48,
            defaultEmployeeIds: [],
            divCellHighlight: undefined,
            divNewBooking: undefined,
            divAppointmentDetails: undefined,
            divWorkTicketSelector: undefined,
            divBlockDetails: undefined,
            scrollContainer: undefined,
            timeZoneOffset: undefined,

            bookContainer: undefined,
            currentActiveBooking: undefined,
            currentPopupDiv: undefined,
            currentPopupHeightWatchFn: undefined,

            parentColumns: undefined,
            columnBookings: [],
            dimensions: [],
            lastRequestedDimension: 0,
            copyCutAppointmentServiceId: undefined,
            columnRight: undefined,
            businessInfo: undefined,
            cutCopyIds: [],

            zIndexTime: 10,
            zIndexStructure: 2,
            zIndexBooking: 5,
            zIndexSchedule: 3,
            zIndexPopup: 11,
            zIndexCellHighlight: 9,
            zIndexClick: 4,
            zIndexDragging: 10,
            zIndexSelected: 6,

            appointmentDataTypeId: 2,
            blockDataTypeId: 3,

            dragOffsetX: undefined,
            dragOffsetY: undefined,
            dragStartingScrollTop: undefined,
            dragStartingScrollLeft: undefined,
            highlightedCell: undefined,
            currentlyDraggableElement: undefined,
            currentlyResizableElements: undefined,

            copyCutMoveBooking: undefined,

            deletedIds: undefined,
            apptServicesBeingCancelledWithFee: undefined,
            appointmentNoShowFeePercentage: 0,
            onApptBookDataSuccess: undefined,
            phoneMode: false,
            isMobile: false,
            previousWindowWidth: 0,
            currentPopupId: undefined,
            disableDateChange: false,
            isEmployeeView: true,
            showZoom: false,
            showViews: false,
            showLeaves: false,
            isDayView: true,

            displayPCNotes: false,
            displayClNotes: false,
            displayStatus: false,

            loadBookOnApplyFilter: false,

            bookLastScrollXPosition: 0,

            requestedAppointmentDefaultFlag: 0,

            maxDoubleBookExpand: 5,
            expandedColumns: [],

            fromDoubleBook: false,
            rebookCandidates: {},

            timeContainerHeight: 0,
            overlapTolerance: 0.5,
            displayPrecisionTimingToggle: false,
            daysBeforeBookingIsAllowed: 0,
            isPasting: false,
            distributeBookingsSegmentPermutationMax: 10000,

            isAmPmFormat: true,
            restrictedIds: {},
            
            textelPermission: false,
            twoWaySmsPermission: false,
            isSmsEnabledCurrentLevel: false,
            primaryAppointmentStyle: Meevo.Model.PrimaryAppointmentStyleSelectionEnum.UseAppointmentCategory
        };
    },
]);
